export default "__VITE_ASSET__264730cf__"